<template>
<div id="app">
  <baner />
  <main>
    <div class="flex-row">
      <div class="wrap">
        <search></search>
        <results></results>
        <bottomFooter></bottomFooter>
      </div>
      <contactForm></contactForm>
    </div>
  </main>
  <loader/>
</div>
</template>

<script>
  import baner from './components/baner.vue'
  import contactForm from './components/form.vue'
  import search from './components/search.vue'
  import results from './components/results.vue'
  import bottomFooter from './components/footer.vue'
  import loader from './components/loader.vue'

  var FontFaceObserver = require('fontfaceobserver');

  export default {
    name: 'app',
    components: {
      baner,
      contactForm,
      search,
      results,
      bottomFooter,
      loader
    },
    mounted() {
      var font = new FontFaceObserver('AudiType');
      font.load().then(function () {
        document.body.className += ' ' + 'font-loaded';
      });


    // UTM FORWARDER
    !function(){function e(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,n)}return r}function t(t){for(var n=1;n<arguments.length;n++){var c=null!=arguments[n]?arguments[n]:{};n%2?e(Object(c),!0).forEach(function(e){r(t,e,c[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(c)):e(Object(c)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(c,e))})}return t}function r(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}new function(){this.getSearchParams=function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").replace("?","").split("&"),t=[];if(""!=e)for(var r=0;r<e.length;r++)t[e[r].split("=")[0]]=e[r].split("=")[1];return t},this.createUtmArray=function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=0;t<this.utmAccepted.length;t++)this.searchParams[this.utmAccepted[t]]&&(e[this.utmAccepted[t]]=this.searchParams[this.utmAccepted[t]]);return e},this.encodeUrlArray=function(e){var t="";for(var r in e)""!=t&&(t+="&"),t+=r+"="+encodeURIComponent(e[r]);return t},this.utmAccepted=["utm_source","utm_medium","utm_campaign","utm_content","utm_term"],this.searchParams=this.getSearchParams(location.search),this.utmParams=this.createUtmArray(),this.hrefs=document.querySelectorAll("a"),this.hrefsIgnore=["tel","mailto"];for(var e=0;e<this.hrefs.length;e++){var r=this.hrefs[e];if(!new RegExp(this.hrefsIgnore.join("|")).test(r.href)){var n=this.getSearchParams(r.search);n=t({},n,{},this.utmParams),r.search=this.encodeUrlArray(n)}}}}();

    }
  }
</script>

<style lang="scss">
  @import url(./assets/fonts/stylesheet.css);
  html,
  body {
    margin: 0;
    padding: 0;
    font-family: Arial;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    @media(max-width: 1280px){
      font-size: 14px;
    }
    @media(max-width: 780px){
      scroll-behavior: smooth;
    }
    position:relative;
    &.font-loaded{
      font-family: 'AudiType';
      textarea{
              font-family: 'AudiType';
      }
    }
  }
  *, *::after, *::before{
    box-sizing:border-box;
  }

  main{
    display:block;
    width:100%;
    max-width: 1920px;
    margin: 0 auto;
  }
  h2{
    font-size: 1.8rem;
  }
  .img-responsive {
    max-width: 100%;
    height: auto;
  }
  .text-center{
    width: 100%;
    text-align: center;
  }
  .flex-row{
    display: block;
    width: 100%;
    @media(min-width:780px){
    display: flex;
    justify-content: flex-end;
    }
  }
  .wrap{
    max-width: 1230px;
    width: 100%;
    @media(min-width: 960px){
      padding-left: 1rem;
    }
  }
</style>
